import { BrandPlan, BrandPlanSchedule, BrandPlanSchedulePlan, BrandPlanTactic, BrandPlanTopics } from 'types'

export interface FormValues
  extends Omit<
    BrandPlanSchedulePlan,
    | 'facebook_topics'
    | 'instagram_topics'
    | 'linkedin_topics'
    | 'twitter_topics'
    | 'tiktok_topics'
    | 'youtube_topics'
    | 'instagram_contents'
  > {
  social_topics: string[]
  video_topics: string[]
  tactics: BrandPlanTactic[]
  instagram_post_contents?: { type: string; count: number }[]
  instagram_story_contents?: { type: string; count: number }[]
  instagram_reel_contents?: { type: string; count: number }[]
}

const groupSocialTopics = (topics: Partial<BrandPlanTopics>): string[] => [
  ...(topics.facebook_topics ?? []),
  ...(topics.instagram_topics ?? []),
  ...(topics.linkedin_topics ?? []),
  ...(topics.twitter_topics ?? []),
]

const groupVideoTopics = (topics: Partial<BrandPlanTopics>): string[] => [
  ...(topics.tiktok_topics ?? []),
  ...(topics.youtube_topics ?? []),
  ...(topics.video_crosspost_topics ?? []),
]

const splitInstagramContentsByType = (contents: any[] | null | undefined) => ({
  post: contents?.filter((item) => item.type === 'post') ?? [],
  story: contents?.filter((item) => item.type === 'story') ?? [],
  reel: contents?.filter((item) => item.type === 'reel') ?? [],
})

export const getInitialPlan = (planOrSchedule: BrandPlan | BrandPlanSchedule | undefined): FormValues => {
  const {
    facebook_contents,
    instagram_contents,
    twitter_contents,
    linkedin_contents,
    seo_contents,
    seo_topics,
    email_contents,
    email_topics,
    tiktok_contents,
    youtube_contents,
    crosspost_contents,
    crosspost_topics,
    video_crosspost_contents,
    video_crosspost_topics,
    google_my_business_contents,
    google_my_business_topics,
    tactics,
    approval_date,
    start_date,
    week_days,
    daily_frequency,
    crosspost_frequency,
  } = planOrSchedule || {}

  const { post, story, reel } = splitInstagramContentsByType(instagram_contents)

  return {
    social_topics: groupSocialTopics(planOrSchedule || {}),
    video_topics: groupVideoTopics(planOrSchedule || {}),
    facebook_contents: facebook_contents ?? [],
    instagram_post_contents: post,
    instagram_story_contents: story,
    instagram_reel_contents: reel,
    twitter_contents: twitter_contents ?? [],
    linkedin_contents: linkedin_contents ?? [],
    seo_contents: seo_contents ?? [],
    seo_topics: seo_topics ?? [],
    email_contents: email_contents ?? [],
    email_topics: email_topics ?? [],
    tiktok_contents: tiktok_contents ?? [],
    youtube_contents: youtube_contents ?? [],
    crosspost_contents: crosspost_contents ?? [],
    crosspost_topics: crosspost_topics ?? [],
    video_crosspost_contents: video_crosspost_contents ?? [],
    video_crosspost_topics: video_crosspost_topics ?? [],
    google_my_business_contents: google_my_business_contents ?? [],
    google_my_business_topics: google_my_business_topics ?? [],
    tactics: tactics || [],
    start_date: start_date ?? '',
    approval_date: approval_date ?? '',
    week_days: week_days ?? [],
    daily_frequency: daily_frequency ?? 'once_a_day',
    crosspost_frequency: crosspost_frequency ?? 'always',
  }
}
